import React, { Component } from "react";
import {
  LongTextInput,
  BooleanInput,
  SelectArrayInput,
  GET_LIST
} from "admin-on-rest";
import PaymentModeForm from "./PaymentModeForm";
import {
  paymentDefaultValue,
  creditMode,
  validatePayment
} from "./defaultValues";
import SelectSupportedMethodsArrayInput from "./SelectSupportedMethodsArrayInput";
import { RestClient } from "../restClient";

class PaymentCRUDForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listBins: []
    };
  }
  getSupportedBins = () => {
    RestClient(GET_LIST, "supportedBins", {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "name", order: "ASC" },
      filter: {}
    })
      .then(items => {
        if (items && items.data && items.data.length > 0) {
          this.setState({
            listBins: items.data
          });
        }
      })
      .catch(e => {
        console.error(e);
      });
  };
  componentWillMount() {
    this.getSupportedBins();
  }
  render() {
    const { listBins } = this.state;
    return (
      <PaymentModeForm
        {...this.props}
        defaultValue={paymentDefaultValue}
        validate={validatePayment}
      >
        <LongTextInput label="resources.paymentmode.field.name" source="name" />
        <BooleanInput
          label="resources.paymentmode.field.active"
          source="active"
        />
        <SelectSupportedMethodsArrayInput
          label="resources.paymentmode.field.supportedMethods"
          source="supported_methods"
          choices={creditMode}
          options={{ fullWidth: true }}
        />
        <SelectArrayInput
          source="supported_bins"
          choices={listBins}
          options={{ fullWidth: true }}
        />
        <BooleanInput
          label="resources.paymentmode.field.installment"
          source="installment"
        />
        <LongTextInput
          label="resources.paymentmode.field.errorMessage"
          source="error_message"
          multiLine={true}
          options={{ rows: 5 }}
        />
      </PaymentModeForm>
    );
  }
}

export default PaymentCRUDForm;



// WEBPACK FOOTER //
// ./src/paymentmode/PaymentCRUDForm.js